import React from 'react';
const Faq = ({ question, answer, id, defaultOpen = false, compact = false, headingLevel = 'h2' }) => {
    const Heading = headingLevel;
    return (React.createElement("details", { id: id, open: defaultOpen || undefined, className: compact
            ? 'group flex flex-col rounded-xl bg-gray-100 px-6 py-3 scroll-mt-28'
            : 'group py-4 px-8 flex flex-col rounded-2xl bg-gray-100' },
        React.createElement("summary", { className: "cursor-pointer flex items-center justify-between gap-4" },
            React.createElement(Heading, { className: compact
                    ? 'text-xl font-semibold leading-6 text-gray-800'
                    : 'md:text-2xl md:leading-8 text-xl leading-7 text-gray-800 font-semibold' }, question),
            React.createElement("span", { className: "material-symbols-outlined transition-transform duration-300 group-open:-rotate-180 text-xl w-6 h-6 text-gray-600 inline-flex items-center justify-center" }, "keyboard_arrow_down")),
        React.createElement("div", { className: compact
                ? 'mt-3 text-base font-normal leading-6 text-gray-700'
                : 'mt-6 text-gray-700 md:text-xl text-base md:leading-8 leading-6 font-normal', dangerouslySetInnerHTML: { __html: answer } })));
};
export default Faq;
